export function parse_settings_field_route(field_raw) {
    const trimmed = field_raw != null ? String(field_raw).replace(/\/+$/, '') : '';
    if (trimmed === '')
        return { base_field: null, integration_key: null };

    let decoded = trimmed;
    try {
        decoded = decodeURIComponent(trimmed);
    } catch (_e) {
        decoded = trimmed;
    }

    const segments = decoded.split('/').filter(Boolean);
    const base_field = segments[0] || null;
    // Only integrations nest a second segment as a catalog key. Mobile deep
    // links use mobile/:env/:section — treating env as integration_key would
    // re-run SettingEdit initialize() on every env/tab switch and wipe edits.
    const integration_key = base_field === 'integrations'
        ? (segments[1] || null)
        : null;

    return { base_field, integration_key };
}

export function integrations_catalog_path(setting_id) {
    return `/settings/edit/${setting_id}/integrations`;
}

export function integrations_config_path(setting_id, integration_key) {
    return `/settings/edit/${setting_id}/integrations/${encodeURIComponent(integration_key)}`;
}
